<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-07-25 16:52:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-07 13:46:43
-->
<template>
  <div class="full_page_grey b-s">
    <div class="f-bt point_info_con">
      <template v-if="isMember">
        <div>
          当前积分<span class="c-ft-40 c-m-l-5">{{ myPointData }}</span>
        </div>
        <div class="f">
          <span @click="handleToRulePage">兑换须知</span>
          <div class="point_history_btn" @click="handleToHistoryPage">
            兑换记录
          </div>
        </div>
      </template>
      <template v-else>
        <div>请登录/注册</div>
        <div class="point_history_btn" @click="handleToRegisterPage">
          去登录/注册
        </div>
      </template>
    </div>
    <van-sticky>
      <div class="point_tab_con">
        <div
          :class="[
            { point_active: nowSortType == 'sort' },
            'f-1 point_tab_item',
          ]"
          @click="handleChangeSortType('sort')"
        >
          <i class="iconfont icon-home-line"></i>
          默认
          <!-- <van-icon name="wap-home-o" /> -->
        </div>
        <div
          :class="[
            { point_active: nowSortType == 'point' },
            'f-1 point_tab_item',
          ]"
          @click="handleChangeSortType('point')"
        >
          <i class="iconfont icon-bonus-line"></i> 积分
          <i
            :class="
              'iconfont arrow_icon ' +
              (isPointSortUp ? 'icon-xiangshang' : 'icon-xiangxia')
            "
          ></i>
        </div>
        <div
          :class="[{ point_active: nowSortType == 'my' }, 'f-1 point_tab_item']"
          @click="handleChangeSortType('my')"
        >
          <i class="iconfont icon-user-line"></i> 我可兑换
        </div>
        <div class="f-1 f point_tab_item">
          <i class="iconfont icon-menu-line"></i>
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="nowPointCatalog"
              :options="pointCatalogOption"
              @change="handleChangeCatalog"
            />
          </van-dropdown-menu>
        </div>
      </div>
    </van-sticky>

    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      :offset="30"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="handleLoadMore"
    >
      <div class="point_list_con">
        <div
          v-for="(item, i) in listData"
          :key="i"
          class="m-b-30 point_list_item"
          @click="handleToPointDetail(item.Id)"
        >
          <div class="point_img_con">
            <img
              class="full_img"
              :src="item.PictureUrl ? item.PictureUrl : $root.defaultImg"
              alt=""
            />
          </div>
          <div class="p-20">
            <p class="point_name_con">{{ item.GoodsName }}</p>
            <p>
              <i class="c-orange">{{ item.Integral }}</i> 积分
              <span v-if="item.Money > 0"
                >+ <i class="c-orange">{{ item.Money }}</i> 元</span
              >
            </p>
          </div>
        </div>
      </div>
    </van-list>
    <van-dialog
      title="兑换须知"
      v-model="showRule"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
    >
      <div class="p-26 induction_con">
        <div class="ql-container ql-snow">
          <div class="ql-editor" v-html="textInduction" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getPointCatalogList, getPointGoodsList } from "@/api/point";
import { getUserCardInfo } from "@/api/member";
import { getGetCouponInfo } from "@/api/activity";
import wxConfig from "@/utils/wxConfig.js";
import { handleLocalStorage } from "@/utils";
import { setToken } from "@/utils/auth";

export default {
  name: "Index",
  props: {},
  data() {
    return {
      isMember: false,
      myPointData: 0, //我的积分数
      nowPointCatalog: "a",
      pointCatalogOption: [
        // { text: "全部", value: "a" },
        // { text: "门票", value: "b" },
        // { text: "优惠券", value: "c" },
        // { text: "商品", value: "d" },
      ],
      nowSortType: "sort",
      isPointSortUp: true,
      listData: [],
      nowPageIndex: 1,
      allPage: 0,
      loading: false,
      finished: false,
      showRule: false,
      textInduction: "",
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      this.loading = true;

      this.handleGetActivityInfo();

      this.handleInitMemberInfo();
      this.handleGetCatalogList();
      this.handleGetDiscountCoupon();
    },
  },
  created() {},
  mounted() {
    this.vpnId = this.$store.state.vpnId;
    if (this.vpnId) {
      this.loading = true;

      this.handleGetActivityInfo();
      this.handleInitMemberInfo();
      this.handleGetCatalogList();
      this.handleGetDiscountCoupon();
    }
  },
  methods: {
    handleGetActivityInfo() {
      getGetCouponInfo({ id: 6, VpnId: this.vpnId }).then((res) => {
        this.textInduction = res.RuleText;
        if (res.EnableShare) {
          // 活动分享图
          let shareImgUrl = "";
          if (res.Claims.length > 0) {
            const imgItem = res.Claims.find((element) => element.TypeId == 3);
            if (imgItem) {
              shareImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
            }
          }
          var _this = this;
          //   // 分享图
          wxConfig.WeChatShare(
            _this,
            location.href,
            data.ShareTitle,
            shareImgUrl,
            data.ShareText
          );
        }
      });
    },
    handleGetCatalogList() {
      getPointCatalogList({ VpnId: this.vpnId }).then((res) => {
        let preArr = [{ text: "全部", value: "a" }];
        res.forEach((item) => {
          preArr.push({ text: item.NodeName, value: item.Id });
        });
        this.pointCatalogOption = preArr;
      });
    },
    handleChangeCatalog() {
      this.handleInitGetCouponList();
    },
    handleInitMemberInfo() {
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if (res.Code) {
          this.isMember = false;
          return;
        }
        if (res.Token) {
          setToken(res.Token);
        }

        this.isMember = true;
        this.myPointData = res.Integral;
        this.MemberAccountId = res.MemberAccountId;
      });
    },
    handleChangeSortType(type) {
      if ((type == "sort" || type == "my") && this.nowSortType == type) return;
      if (!this.isMember && type == "my") {
        return this.$toast("您还不是本店微会员，请先注册");
      }
      if (type == "point" && this.nowSortType == "point") {
        this.isPointSortUp = !this.isPointSortUp;
      }
      this.nowSortType = type;
      this.handleInitGetCouponList();
    },
    // 获取优惠券列表
    handleGetDiscountCoupon(flag) {
      // this.listData = [
      //   {
      //     ProductId: "299792466",
      //     TicketName: "商品aaaaa山东济南还是女孩简单",
      //     Price: 10,
      //     Integal: 100,
      //     imgUrl:
      //       "http://saas-ticket.oss-cn-beijing.aliyuncs.com/299792460/c72Y8DY6Xd.jpeg",
      //   },
      //   {
      //     ProductId: "299792466",
      //     TicketName: "清华池修脚",
      //     Price: 0,
      //     Integal: 200,
      //     imgUrl:
      //       " http://saas-ticket.oss-cn-beijing.aliyuncs.com/299792460/5hSynyJdEk.jpeg",
      //   },
      //   {
      //     ProductId: "299792466",
      //     TicketName: "商品aaaaa山东济南还是女孩简单",
      //     Price: 10,
      //     Integal: 100,
      //     imgUrl:
      //       "http://saas-ticket.oss-cn-beijing.aliyuncs.com/299792460/fTtKtKaS24.jpeg",
      //   },
      // ];
      // this.allPage = 1;
      // this.loading = false;
      // this.finished = true;
      let params = { vpnId: this.vpnId };
      if (this.nowPointCatalog != "a") {
        params.GoodsCatalogId = this.nowPointCatalog;
      }

      if (this.nowSortType == "point") {
        params.SortByIntegral = this.isPointSortUp ? 0 : 1;
      }
      if (this.nowSortType == "my") {
        params.MaxIntegral = this.myPointData;
      }

      getPointGoodsList({
        query: params,
        pager: { pageindex: this.nowPageIndex, pagesize: 10 },
      })
        .then((res) => {
          // res.Items.forEach((v) => {
          //   v.UseEndDate = v.UseEndDate.split(" ")[0];
          //   v.UseStartDate = v.UseStartDate.split(" ")[0];
          // });
          this.listData = this.listData.concat(res.Items);

          //   // 数据全部加载完成
          if (this.listData.length >= res.Pager.TotalCount) {
            this.finished = true;
          }
          //   // 加载状态结束
          this.loading = false;
        })
        .catch(() => {
          this.loadError = true;

          this.loading = false;
          this.finished = true;
        });
    },
    handleInitGetCouponList() {
      this.listData = [];
      this.nowPageIndex = 1;
      this.handleGetDiscountCoupon();
    },
    handleLoadMore() {
      // if (this.nowPageIndex + 1 < this.allPage) {
      this.nowPageIndex++;
      this.handleGetDiscountCoupon();
      // }
    },
    //  查看产品详情
    handleToPointDetail(Id) {
      if (!this.isMember) {
        return this.$toast("您还不是本店微会员，请先注册");
      }
      handleLocalStorage.set("pointData", {
        memberAccountId: this.MemberAccountId,
        memberPoint: this.myPointData,
      });

      this.$router.push({
        name: "FlashSalePage",
        params: { id: Id },
        query: {
          fromPage: "point",
        },
      });
    },
    handleToHistoryPage() {
      this.$router.push({
        name: "PointHistoryPage",
      });
      // this.$router.push("/homePage/order");
    },
    handleToRegisterPage() {
      this.$router.push({
        name: "ValidMember",
      });
    },
    handleToRulePage() {
      this.showRule = true;
    },
    hideModel() {
      this.showRule = false;
    },
  },
};
</script>
<style scoped lang="scss">
// .container /deep/ .van-tab {
//   width: 250rpx;
// }
.point_info_con {
  padding-left: 20px;
  height: 240px;
  // background: rgb(236, 182, 32);
  background: url("../../assets/images/point-bg.png") no-repeat top left/100%
    auto;
  color: #fff;
  .point_history_btn {
    padding: 6px 10px;
    border-radius: 20px 0 0 20px;
    background: #fff;
    color: #ff9f00;
    margin-left: 30px;
  }
}
.point_tab_con {
  display: flex;
  align-items: center;
  background: #fff;
  .point_tab_item {
    justify-content: center;
    color: #999;
    text-align: center;
    &.point_active {
      color: #ff9f00;
    }
    .iconfont {
      font-size: 32px;
      vertical-align: -2px;
      &.arrow_icon {
        font-size: 26px;
        vertical-align: unset;
      }
    }
  }
}
.point_list_con {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}
.point_list_item {
  background: #fff;
  width: 48%;
  border-radius: 30px;
  margin-right: 20px;
  overflow: hidden;
  &:nth-child(2n) {
    margin-right: 0;
  }
  .point_img_con {
    height: 300px;
  }
  .point_name_con {
    margin-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.induction_con {
  height: 600px;
  overflow: auto;
  ::v-deep img {
    width: 100%;
    vertical-align: middle;
  }
}
</style>
